import { render } from "./add-test.vue?vue&type=template&id=5f701f28&scoped=true"
import script from "./add-test.vue?vue&type=script&lang=js"
export * from "./add-test.vue?vue&type=script&lang=js"

import "./add-test.vue?vue&type=style&index=0&id=5f701f28&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f701f28"]])

export default __exports__